export default {
  // Không gửi duyệt được do hồ sơ đã được Thủ trưởng từ chối duyệt
  CompanyDirectorReject: -2,
  // Không gửi duyệt được do hồ sơ đã được gửi cho KTT duyệt
  Waiting: 0,
  // Không gửi duyệt được do hồ sơ đã được gửi cho Thủ trưởng duyệt
  WaitingCompanyDirector: 2,
  // Không gửi duyệt được do hồ sơ đã được Thủ trưởng duyệt
  CompanyDirectorApproved: 3,
  // Không gửi duyệt được hồ sơ của Kế toán trưởng tự tạo
  CreatedByChiefAccountant: 5,
};
